import { helper } from "@ember/component/helper";

export const colors = ["green", "blue", "red", "outline", "link", "gray-dark", "gray"];

export function gButtonColor(color) {
  switch (color[0]) {
    case "green":
      return "bg-green-100 border hover:bg-green-100/80 hover:border-green-100/80 border-green-100 text-black";
    case "blue":
      return "bg-indigo-700 border hover:bg-indigo-700/80 hover:border-indigo-700/80 border-indigo-700 text-white hover:text-white";
    case "red":
      return "bg-red-600 border hover:bg-red-700 hover:border-red-700 border-red-600 text-white hover:text-white";
    case "outline":
      return "bg-white hover:border-gray-300 border border-gray-200 hover:text-black text-gray-800";
    case "link":
      return "text-gray-500 border hover:border-gray-200 border-transparent hover:text-gray-800 hover:bg-gray-400 bg-transparent";
    case "gray-dark":
      return "text-gray-800 border hover:border-gray-200 border-gray-200 hover:text-black hover:bg-gray-400 bg-gray-400";
    case "gray":
    default:
      return "text-gray-800 border hover:border-gray-300 border-gray-200 hover:text-black hover:bg-gray-300 bg-gray-200";
  }
}

export default helper(gButtonColor);
